// extracted by mini-css-extract-plugin
export default {"images":"UserCard_images__iWSbU","icon":"UserCard_icon__ttRE+","iconContainer":"UserCard_iconContainer__+wDQH"};